import { Provider } from '@angular/core';
import { DatasourceTableJobServiceInjectionToken } from '@y42/datasource';
import { IntegrationTableJobService } from '@y42/integration';
import { SqlModelingTableJobService } from '@y42/sql-model';
import { UiModelingTableJobService } from '@y42/ui-model';

export function provideDatasourceTableJobServices(): Provider[] {
  return [
    {
      provide: DatasourceTableJobServiceInjectionToken,
      multi: true,
      useExisting: IntegrationTableJobService,
    },
    {
      provide: DatasourceTableJobServiceInjectionToken,
      multi: true,
      useExisting: UiModelingTableJobService,
    },
    {
      provide: DatasourceTableJobServiceInjectionToken,
      multi: true,
      useExisting: SqlModelingTableJobService,
    },
  ];
}
